<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <GarageAccreditedForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import GarageAccreditedForm from '@/components/settings/test-registers/garageAccredited/GarageAccreditedForm'

export default {
  name: 'GarageAccrediteds',
  components: {
    PageTitle,
    PageRowWrapper,
    GarageAccreditedForm
  }
}
</script>
